import React from 'react';

type Props = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet'> & {
  previewUrl?: string | null;
  originalUrl?: string | null;
};

/** A failed transform must not hide the original evidence or retry forever. */
export default function PreviewImage({ previewUrl, originalUrl, alt = '', ...props }: Props) {
  const [failedPreview, setFailedPreview] = React.useState<string>();
  const preview = previewUrl || originalUrl || undefined;
  return <img loading="lazy" decoding="async" width={640} height={480} {...props}
    src={failedPreview === preview ? originalUrl || undefined : preview} alt={alt}
    onError={event => {
      if (preview && preview !== originalUrl && failedPreview !== preview) setFailedPreview(preview);
      else props.onError?.(event);
    }}
  />;
}
